import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { TrendingDown, TrendingUp } from 'lucide-react';
import { t, getLocale } from '@/i18n';

const fmt = (n, digits = 1) => n.toLocaleString(getLocale(), { maximumFractionDigits: digits });

// One KPI: current value, the pre-pilot baseline and whether the change is good.
const Kpi = ({ label, value, unit, before, lowerIsBetter, hint }) => {
  const improved = before == null ? null : lowerIsBetter ? value < before : value > before;
  const Icon = before == null ? null : value < before ? TrendingDown : TrendingUp;
  return (
    <Card className="p-4">
      <div className="text-xs text-muted-foreground">{label}</div>
      <div className="text-2xl font-bold mt-1 tabular-nums">
        {fmt(value)}<span className="text-sm font-medium text-muted-foreground"> {unit}</span>
      </div>
      {before != null ? (
        <div className={cn('flex items-center gap-1 text-xs mt-1', improved ? 'text-emerald-700' : 'text-red-700')}>
          <Icon className="h-3 w-3" /> {t('stats.beforePilot')}: {fmt(before)} {unit}
        </div>
      ) : (
        <div className="text-xs mt-1 text-muted-foreground">{hint}</div>
      )}
    </Card>
  );
};

export const StatsKpis = ({ summary }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
    <Kpi label={t('stats.kpi.noShows')} value={summary.noShows.now} before={summary.noShows.before} unit={t('stats.unit.perDay')} lowerIsBetter />
    <Kpi label={t('stats.kpi.informed')} value={summary.informedPct.now} before={summary.informedPct.before} unit="%" />
    <Kpi
      label={t('stats.kpi.urgencies')}
      value={summary.urgencies.now}
      unit={t('stats.unit.perDay')}
      hint={`${fmt(summary.urgencies.autoPct, 0)} % ${t('stats.kpi.autoResolved')}`}
    />
    <Kpi label={t('stats.kpi.parking')} value={summary.parkingTrucks.now} before={summary.parkingTrucks.before} unit={t('stats.unit.trucksPerNight')} lowerIsBetter />
  </div>
);
